import {Space} from "antd";
import {
  StyledDocUploadVideo,
  StyledDocUploadVideoWrapper,
  StyledKycStatusRiveWrapper,
} from "../../create-kyc/multi-step/document-upload/file-upload-field/styles";
import {
  StyledKycVerificationViewTextWrapper,
  StyledKycVerificationViewWrapper,
} from "./styles";
import React from "react";
import {useRive, Layout, Fit, Alignment} from "@rive-app/react-canvas";
import RiveAnimations from "../../../../assets/kyc_assets.riv";

type KycVerificationViewProps = {
  videoSrc: "KYC successful" | "KYC pending" | "KYC failed";
  title: string;
  description: React.ReactNode;
};

export function KycVerificationView({
  description,
  title,
  videoSrc,
}: KycVerificationViewProps) {
  const {RiveComponent} = useRive({
    src: RiveAnimations,
    // animations: ["play"],
    layout: new Layout({
      fit: Fit.Contain, // Change to: rive.Fit.Contain, or Cover
      alignment: Alignment.Center,
    }),
    autoplay: true,
    artboard: videoSrc,
    stateMachines: "State Machine 1",
  });
  return (
    <Space size={24} direction="vertical" style={{display: "flex"}}>
      <StyledKycVerificationViewWrapper>
        <StyledDocUploadVideoWrapper>
          <StyledKycStatusRiveWrapper>
            <RiveComponent />
          </StyledKycStatusRiveWrapper>
        </StyledDocUploadVideoWrapper>
        <StyledKycVerificationViewTextWrapper>
          <Space size={16} direction="vertical" style={{display: "flex"}}>
            <p className="title">{title}</p>
            <p className="description">{description}</p>
          </Space>
        </StyledKycVerificationViewTextWrapper>
      </StyledKycVerificationViewWrapper>
    </Space>
  );
}
